import React from 'react';
import propTypes from 'prop-types';
import format from 'react-format-props';
import { compose } from 'redux';
import pathfinder from '@fiverr-private/pathfinder';
import * as I18n from '../../lib/hoc';
import * as apps from '../../enums/apps';
import ButtonToggleSounds from '../ButtonToggleSounds';
import './style.scss';

export function DrawerFooter({ editNotificationsUrl, inboxUrl, showViewAll, i18n, notificationSoundEnabled }) {
    return (
        <footer className="drawer-footer">
            <ButtonToggleSounds notificationSoundEnabled={notificationSoundEnabled} />
            <a href={editNotificationsUrl} target="_blank" rel="noopener noreferrer" className="btn-settings" />
            {showViewAll && (
                <a href={inboxUrl} className="view-all">
                    {i18n.t('realtime_notifications.notifications_drawer.see_all_in_inbox')}
                </a>
            )}
        </footer>
    );
}

DrawerFooter.propTypes = {
    editNotificationsUrl: propTypes.string,
    inboxUrl: propTypes.string,
    showViewAll: propTypes.bool,
    notificationSoundEnabled: propTypes.bool,
    i18n: propTypes.shape({
        t: propTypes.func,
    }),
};

export default compose(
    I18n.connect,
    format(({ active, username, notificationSoundEnabled, i18n }) => ({
        editNotificationsUrl: pathfinder('edit_user_section', {
            id: username,
            section: 'notifications',
        }),
        notificationSoundEnabled,
        inboxUrl: pathfinder('inbox'),
        showViewAll: active === apps.APP_NAME_INBOX,
        i18n,
    }))
)(DrawerFooter);
